import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import TermosDeUsoSP from '../content/legal/sao-paulo/TermosDeUsoSP';
import TermosDeUsoBH from '../content/legal/belo-horizonte/TermosDeUsoBH';
import resolverCidadeSlug from '../utils/cidadeAtiva';
import '../assets/scss/components/TermosDeUso.scss';

const TermosDeUso = ({ cidade }) => {
  const history = useHistory();
  const modal = useRef();

  const cidadeSlug = resolverCidadeSlug(cidade, history.location.pathname);

  const back = (e) => {
    e.stopPropagation();
    const baseRoute = history.location.pathname.replace(
      /\/termos-de-uso$|\/lgpd$/,
      ''
    );
    history.push(baseRoute || '/');
  };

  const handleModal = (e) => {
    if (modal.current !== null && modal.current !== undefined) {
      if (!modal.current.contains(e.target)) {
        back(e);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleModal);
    return () => {
      document.removeEventListener('mousedown', handleModal);
    };
  }, []);

  return (
    <div className="wrapper-termos">
      <div className="modal" ref={modal}>
        <div className="container">
          {cidadeSlug === 'belo-horizonte' ? (
            <TermosDeUsoBH />
          ) : (
            <TermosDeUsoSP />
          )}
          <div className="actions">
            <button type="button" onClick={back}>
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

TermosDeUso.propTypes = {
  cidade: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      slug: PropTypes.string
    })
  ])
};

TermosDeUso.defaultProps = {
  cidade: null
};

export default TermosDeUso;
